var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import api from './api';
import { getHeader } from './header';
// ✅ API Functions
/**
 * Busca lista de feedbacks do usuário
 */
export var getMyFeedbacks = function () { return __awaiter(void 0, void 0, Promise, function () {
    var header, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getHeader()];
            case 1:
                header = _a.sent();
                return [4 /*yield*/, api.get('/feedbacks/my-feedbacks', header)];
            case 2:
                response = _a.sent();
                return [2 /*return*/, response.data];
        }
    });
}); };
/**
 * Busca todos os feedbacks (admin)
 */
export var getAllFeedbacks = function () { return __awaiter(void 0, void 0, Promise, function () {
    var header, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getHeader()];
            case 1:
                header = _a.sent();
                return [4 /*yield*/, api.get('/feedbacks', header)];
            case 2:
                response = _a.sent();
                return [2 /*return*/, response.data];
        }
    });
}); };
/**
 * Busca um feedback específico por ID
 */
export var getFeedback = function (feedbackId) { return __awaiter(void 0, void 0, Promise, function () {
    var header, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getHeader()];
            case 1:
                header = _a.sent();
                return [4 /*yield*/, api.get("/feedbacks/".concat(feedbackId), header)];
            case 2:
                response = _a.sent();
                return [2 /*return*/, response.data];
        }
    });
}); };
/**
 * Cria um novo feedback
 */
export var createFeedback = function (data) { return __awaiter(void 0, void 0, Promise, function () {
    var header, formData, response_1, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getHeader()];
            case 1:
                header = _a.sent();
                if (!data.screenshot_file) return [3 /*break*/, 3];
                formData = new FormData();
                formData.append('type', data.type);
                formData.append('title', data.title);
                formData.append('description', data.description);
                formData.append('page_url', data.page_url);
                formData.append('page_name', data.page_name);
                if (data.user_agent)
                    formData.append('user_agent', data.user_agent);
                if (data.screen_resolution)
                    formData.append('screen_resolution', data.screen_resolution);
                if (data.screenshot_file)
                    formData.append('screenshot_file', data.screenshot_file);
                return [4 /*yield*/, api.post('/feedbacks', formData, __assign(__assign({}, header), { headers: __assign(__assign({}, header.headers), { 'Content-Type': 'multipart/form-data' }) }))];
            case 2:
                response_1 = _a.sent();
                return [2 /*return*/, response_1.data];
            case 3: return [4 /*yield*/, api.post('/feedbacks', data, header)];
            case 4:
                response = _a.sent();
                return [2 /*return*/, response.data];
        }
    });
}); };
/**
 * Adiciona uma mensagem ao feedback
 */
export var addFeedbackMessage = function (feedbackId, message, screenshot) { return __awaiter(void 0, void 0, Promise, function () {
    var header, formData, response_2, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getHeader()];
            case 1:
                header = _a.sent();
                if (!(screenshot instanceof File)) return [3 /*break*/, 3];
                formData = new FormData();
                formData.append('message', message);
                formData.append('screenshot_file', screenshot);
                return [4 /*yield*/, api.post("/feedbacks/".concat(feedbackId, "/add-message"), formData, __assign(__assign({}, header), { headers: __assign(__assign({}, header.headers), { 'Content-Type': 'multipart/form-data' }) }))];
            case 2:
                response_2 = _a.sent();
                return [2 /*return*/, response_2.data];
            case 3: return [4 /*yield*/, api.post("/feedbacks/".concat(feedbackId, "/add-message"), { message: message, screenshot: screenshot }, header)];
            case 4:
                response = _a.sent();
                return [2 /*return*/, response.data];
        }
    });
}); };
/**
 * Altera o status do feedback (admin)
 */
export var changeFeedbackStatus = function (feedbackId, status, admin_response) { return __awaiter(void 0, void 0, Promise, function () {
    var header, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getHeader()];
            case 1:
                header = _a.sent();
                return [4 /*yield*/, api.post("/feedbacks/".concat(feedbackId, "/change-status"), { status: status, admin_response: admin_response }, header)];
            case 2:
                response = _a.sent();
                return [2 /*return*/, response.data];
        }
    });
}); };
/**
 * Vota em um feedback
 */
export var upvoteFeedback = function (feedbackId) { return __awaiter(void 0, void 0, Promise, function () {
    var header, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getHeader()];
            case 1:
                header = _a.sent();
                return [4 /*yield*/, api.post("/feedbacks/".concat(feedbackId, "/upvote"), {}, header)];
            case 2:
                response = _a.sent();
                return [2 /*return*/, response.data];
        }
    });
}); };
/**
 * Busca estatísticas de feedbacks (admin)
 */
export var getFeedbackStats = function () { return __awaiter(void 0, void 0, Promise, function () {
    var header, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getHeader()];
            case 1:
                header = _a.sent();
                return [4 /*yield*/, api.get('/feedbacks/stats', header)];
            case 2:
                response = _a.sent();
                return [2 /*return*/, response.data];
        }
    });
}); };
/**
 * Converte File para Base64
 */
export var convertFileToBase64 = function (file) {
    return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.onload = function () {
            var result = reader.result;
            // Remove o prefixo "data:image/...;base64,"
            var base64 = result.split(',')[1];
            resolve(base64);
        };
        reader.onerror = reject;
        reader.readAsDataURL(file);
    });
};
/**
 * Captura screenshot da tela atual (usando html2canvas se disponível)
 */
export var captureScreenshot = function () { return __awaiter(void 0, void 0, Promise, function () {
    var canvas, base64, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                if (!(typeof window !== 'undefined' && window.html2canvas)) return [3 /*break*/, 2];
                return [4 /*yield*/, window.html2canvas(document.body, {
                        logging: false,
                        useCORS: true,
                        allowTaint: true
                    })];
            case 1:
                canvas = _a.sent();
                base64 = canvas.toDataURL('image/jpeg', 0.85).split(',')[1];
                return [2 /*return*/, base64];
            case 2: return [2 /*return*/, null];
            case 3:
                error_1 = _a.sent();
                console.error('Erro ao capturar screenshot:', error_1);
                return [2 /*return*/, null];
            case 4: return [2 /*return*/];
        }
    });
}); };
